<script setup lang="ts">
import { ref } from 'vue';
import InfoIcon from '@/components/icons/InfoIcon.vue';
import Popover from '@/components/popovers/Popover.vue';
import ResponsivePopover from '@/components/popovers/ResponsivePopover.vue';

type Props = {
  tooltip?: boolean;
  iconSize?: 1 | 2 | 3 | 4;
  responsive?: boolean;
  location?: 'start' | 'end' | 'top' | 'bottom';
};

const props = withDefaults(defineProps<Props>(), {
  tooltip: true,
  iconSize: 2,
  responsive: false,
});

const hover = ref(false);
</script>

<template>
  <div>
    <InfoIcon v-model="hover" :icon-size="props.iconSize"></InfoIcon>

    <Popover
      v-if="props.tooltip"
      activator="parent"
      title-divider
      v-model="hover"
      max-width="500px"
    >
      <template #title>
        <div class="flex items-center text-subtitle-1 gap-2">
          <v-icon icon="fat fa-circle-info" class="text-icon-3" color="iconSolid"></v-icon>
          <slot name="title"> </slot>
        </div>
      </template>

      <template #content>
        <slot name="content"></slot>
      </template>
    </Popover>

    <ResponsivePopover
      v-else
      activator="parent"
      header
      title-divider
      hover
      info-icon
      :max-width="500"
      :location="props.location"
    >
      <template #title>
        <div class="flex items-center text-subtitle-1 gap-2">
          <slot name="title"> </slot>
        </div>
      </template>

      <template #content>
        <slot name="content"></slot>
      </template>
    </ResponsivePopover>
  </div>
</template>
